import { rolesSlice } from "./rolesSlice";
import * as actions from "./rolesActions";
import * as selectors from "./rolesSelectors";

export { actions };
export { selectors };
export default rolesSlice.reducer;
